import React, {useState} from "react"
// import theme from "./../../../Theme/Theme"
import { Div, Text } from "atomize";
import ActivityChip from "./../../Atoms/ActivityChip";
import styled from "styled-components";

const Wrapper = styled(Div)`
    margin-top: 1rem;
`;

function ActivitiesGroup(props) {
  const [overflow, setOverflow] = useState(false);

  if (props.activities.length > 0 && props.overflow) {
    return (
      <Wrapper
      >
        {
          props.activities.map( (activity, i )=> {
            if (i <= 5 ) {
              return (
                <ActivityChip
                  key={activity.id + i }
                  id={activity.id}
                  dismissable={props.dismissable ? props.dismissable : false}
                />
              )
            }
          })
        }
        {
          props.activities.length > 5 && !overflow &&
          <a
            style={{display: 'block'}}
            href={''}
            onClick={
              (e) => {
                e.preventDefault();
                setOverflow(true);
              }
            }
          >{ props.activities.length - 6} more</a>
        }
        {
          overflow &&
          props.activities.map( (activity, i )=> {
            if (i > 5 ) {
              return (
                <ActivityChip
                  key={activity.id + i }
                  id={activity.id}
                  dismissable={props.dismissable ? props.dismissable : false}
                />
              )
            }
          })
        }
        {
          props.activities.length > 5 && overflow &&
          <a
            style={{display: 'block'}}
            href={''}
            onClick={
              (e) => {
                e.preventDefault();
                setOverflow(false);
              }
            }
          >hide { props.activities.length - 6}</a>
        }
      </Wrapper>
    )
  }
  else if (props.activities.length > 0) {
    return (
      <Wrapper
      >
        {
          props.activities.map( (activity, i )=> {
            return (
              <ActivityChip
                key={activity.id + i }
                id={activity.id}
                dismissable={props.dismissable ? props.dismissable : false}
              />
            )
          })
        }
      </Wrapper>
    )
  } else return <></>
}

export default ActivitiesGroup
